angular.module 'App.Module.BaseSearch', []
